import { render, staticRenderFns } from "./BlogDetailsWrapper.vue?vue&type=template&id=0b587a04&"
import script from "./BlogDetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./BlogDetailsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports